<!-- File icon badge showing an uppercase file extension label. -->

<script lang="ts" setup>
import { File as FileIcon } from 'lucide-vue-next';

interface Props {
  extension: string;
}

defineProps<Props>();
</script>

<template>
  <div :class="css.fileExtension">
    <FileIcon
      :size="32"
      stroke-width="1.5"
    />
    <span :class="css.extensionLabel">{{ extension }}</span>
  </div>
</template>

<style lang="scss" module="css">
.fileExtension {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: inherit;
  color: var(--file-extension-color, #{$color-gray-600});
}

.extensionLabel {
  position: absolute;
  bottom: 7px;
  left: 10px;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  pointer-events: none;
  color: var(--file-extension-label-color, #{$color-gray-700});
  line-height: 1.2;
  min-width: 30px;
  background: inherit;
}
</style>
